<script>
/**
 * ESTE COMPONENTE DEFINE LOS ROWS DE LA TABLA
 * 
 * @ejemplo
 * <DatagridRow>
 * ...
 * </DatagridRow>
 */    
    import {breakpoint, platform} from './MediaQuery.svelte'
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let id=false
    export let seleccionado=false
    export let disabled=false
    export let hideCheckbox=false

    let checked=false;
    let select=function () {
        if(disabled==false)
        {
            dispatch('select', { id: id });
        }
		
    }
</script>

{#if $breakpoint=='xs' || $breakpoint=='sm' || $breakpoint=='md'}
    <div class='border-bottom border-2 border-secondary mb-1 pb-1 cursor' class:bg-warning={seleccionado==id} on:click={select}>
        <table class='table table-sm mb-0'>
            <tbody>
                <slot/>
            </tbody>
        </table>
    </div>
{:else}
    <tr on:click={select} class:bg-warning={seleccionado==id} class='cursor'>
        {#if hideCheckbox===false}
            <td width='width:40px;'><input class="form-check-input " type="checkbox" checked={seleccionado==id} disabled={disabled}></td>
        {/if}
        <slot/>
    </tr>
{/if}

<style>
    .cursor {
        cursor:pointer;
    }
</style>